(() => {
  if (customElements.get('psc-refund-agreement')) return;
  customElements.define('psc-refund-agreement', class extends HTMLElement {
    connectedCallback() {
      const checkbox = this.querySelector('input[type="checkbox"]');
      if (!checkbox || this.dataset.ready) return;
      this.dataset.ready = 'true';
      checkbox.checked = false;
      checkbox.addEventListener('change', (event) => {
        event.stopPropagation();
        this.querySelector('[data-psc-refund-timestamp]').value = '';
      });
    }
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const checkbox = Array.from(form.elements).find((field) => field.name === 'attributes[Refund and return policy agreement]');
    if (!checkbox) return;
    if (!checkbox.checked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      checkbox.reportValidity();
      checkbox.focus();
      return;
    }
    const timestamp = Array.from(form.elements).find((field) => field.name === 'attributes[Refund policy accepted at UTC]');
    if (timestamp) timestamp.value = new Date().toISOString();
  }, true);
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('psc-refund-agreement input[type="checkbox"]').forEach((input) => { input.checked = false; });
    document.querySelectorAll('[data-psc-refund-timestamp]').forEach((input) => { input.value = ''; });
  });
})();
